import React from "react";
import HeroSection from "../components/venue/HeroSection";
import RoomInfo from "../components/venue/RoomInfo";
import PricingSection from "../components/venue/PricingSection";
import BookingSection from "../components/venue/BookingSection";

/**
 * Hauptseite der Anwendung
 * Rendert alle Sektionen der Venue-Website in der richtigen Reihenfolge
 * Jede Sektion ist eine eigenständige Komponente mit spezifischer Funktionalität
 * 
 * Diese Seite dient als Landing Page für den Veranstaltungsraum und
 * führt Besucher durch alle wichtigen Informationen und Aktionen
 */
export default function Home() {
  /**
   * Callback-Funktion für erfolgreiche Buchungen
   * Wird später für echte API-Aufrufe und Benachrichtigungen erweitert
   * 
   * Aktuell wird nur eine Konsolen-Ausgabe gemacht, aber hier können
   * später Analytics, Benachrichtigungen oder andere Aktionen hinzugefügt werden
   */
  const handleBookingSuccess = () => {
    console.log("Buchung erfolgreich!");
  };

  return (
    <div className="min-h-screen">
      {/* Hero-Sektion mit Haupttitel und Call-to-Action */}
      <section id="navigation" aria-label="Hauptnavigation">
        <HeroSection />
      </section>
      
      {/* Informationen über den Veranstaltungsraum */}
      <section id="main-content" aria-label="Hauptinhalt">
        <RoomInfo />
      </section>
      
      {/* Preismodelle und Konditionen */}
      <PricingSection />
      
      {/* Buchungsbereich mit Kalender und Formular */}
      <section id="booking-section" aria-label="Buchungsbereich">
        <BookingSection 
          onBookingSuccess={handleBookingSuccess}
        />
      </section>
    </div>
  );
}